
export default {
  props: {
    config: {
      default: function _default() {
        return {};
      }
    },
    formValue: {
      default: function _default() {
        return {};
      }
    },
    model: {
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.$emit('click', this.formValue.$index);
    }
  }
};